import React, { useEffect, useState } from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { SettingsState } from '../../../organisms/SelectSettings';
import {
  Paper,
  Table,
  TableContainer,
  TableBody,
  TableRow,
  TableCell,
  TextField,
  TableHead,
  Checkbox,
  Button,
} from '@material-ui/core';
import {
  GroupListType,
  GetRealtimeGroupList,
  GetRealtimeSetting,
  PutRealtimeGroupSetting,
  RT_TRD_GROUP_SET,
  V_RT_TREND_SETTING_ITEM,
  JudgeInfo,
  PlcInfo,
  ColSetInfo,
  KIND_NO_NAME_SET,
} from '../../../../function/GroupDataModel';
import ItemComboBox, { ComboBoxItemType } from '../../../atoms/ComboBox/ItemComboBox';
import RealtimeSettingItem from './RealtimeSettingItem';
import SaveCancel from '../SaveCancel';
import ColorPicker from '../ColorPicker';
import ListControl from '../ListControl';
import { useMemo } from 'react';
import { useModal } from '../../../../function/useModal';
import ConfirmDialog, { ConfirmDialogResponse } from '../../../atoms/Dialog/ConfirmDialog';
import MessageDialog, { MessageDialogResponse } from '../../../atoms/Dialog/MessageDialog';
import { useTranslation } from 'react-i18next';
import CreateGroupDialog, { CreateGroupDialogResponse } from '../CreateGroupDialog';
import {
  MeasureHighKind,
  MeasureClcType,
  AlmTypKind,
  GetVibrationSpecialNo,
  GetVibrationSpecialNoUnit,
  GetVibrationSpecialString,
  GetMeasureClcName,
  SpeedKind,
} from '../../../../Constant';

import {
  GetDefaultPenColor,
  CreateInitColSetInfo,
  CreateSpecialDatTrendSettingParameter,
} from '../TrendSetting/TrendSetting';
import { TableBaseStyle, RealtimeSettingStyle } from './RealtimeSettingStyle';
import { JudgeSettingSelectType, GetJudgeSettingSelectItems } from '../../../../function/JudgeSettingSelectModel';
import { IsConanAirPlc } from '../../../../function/PlcNoModel';

type RealtimeSettingProps = {
  editData: SettingsState;
  groupNo?: number;
  isDialog: boolean;
};

type SaveParameter = {
  group: RT_TRD_GROUP_SET;
  list: V_RT_TREND_SETTING_ITEM[];
  colset: ColSetInfo[];
};

const MaxSettingRow: number = 8;
const MaxGroup: number = 128;

const createComboList = (groups: RT_TRD_GROUP_SET[]): ComboBoxItemType[] => {
  return groups.map<ComboBoxItemType>((grp) => {
    return { index: grp.GROUP_NO, name: grp.GROUP_NO.toString() };
  });
};

const RealtimeSettingPage: React.FC<RealtimeSettingProps> = (props: RealtimeSettingProps) => {
  const { t, i18n } = useTranslation();
  const tableStyle = TableBaseStyle();
  const pageStyle = RealtimeSettingStyle();
  const [groupNo, setGroupNo] = useState<number>(0);
  const [editList, setEditList] = useState<RT_TRD_GROUP_SET[]>([]);
  const [groupName, setGroupName] = useState<string>('');
  const [groupCombos, setGroupCombos] = useState<ComboBoxItemType[]>();
  const [measCombos, setMeasCombos] = useState<ComboBoxItemType[]>([]);
  const [deviceCombos, setDeviceCombos] = useState<ComboBoxItemType[]>([]);
  const [itemCombos, setItemCombos] = useState<ComboBoxItemType[]>([]);
  const [dataCombos, setDataCombos] = useState<ComboBoxItemType[]>([]);
  const [alarmCombos, setAlarmCombos] = useState<ComboBoxItemType[]>([]);
  const [mClcTypeCombos, setMClcTypeCombos] = useState<ComboBoxItemType[]>([]);

  const [judgeInfo, setJudgeInfo] = useState<JudgeInfo[]>([]);

  const [itemList, setItemList] = useState<V_RT_TREND_SETTING_ITEM[]>([]);
  const [kindNoNameSets, setKindNoNameSets] = useState<KIND_NO_NAME_SET[]>([]);
  const [deviceUnitInfo, setDeviceUnitInfo] = useState<PlcInfo[]>([]);
  const [judgeSetSelect, setJudgeSetSelect] = useState<JudgeSettingSelectType[]>([]);
  const [colSetInfo, setColSetInfo] = useState<ColSetInfo[]>([]);
  const [cursorColor, setCursorColor] = useState<number>(0);
  const [dispFlg, setDispFlg] = useState<boolean>(false);
  const [period, setPeriod] = useState<number>(1);
  const [autoUpdate, setAutoUpdate] = useState<boolean>(false);
  const [selectIdx, setSelectIdx] = useState<number>(-1);
  const [flgCfmDlg, actCfmDlg] = useModal<ConfirmDialogResponse>();
  const [flgMsgDlg, actMsgDlg] = useModal<MessageDialogResponse>();
  const [dlgmsg, setDlgmsg] = useState<string>('');
  const [flgCrtDlg, actCrtDlg] = useModal<CreateGroupDialogResponse>();

  const cfmdlg = flgCfmDlg ? (
    <ConfirmDialog
      dialog={actCfmDlg}
      message={dlgmsg}
      action={t('RealtimeSetting.はい', 'はい')}
      cancel={t('RealtimeSetting.いいえ', 'いいえ')}
    />
  ) : null;
  const msgdlg = flgMsgDlg ? <MessageDialog dialog={actMsgDlg} message={dlgmsg} /> : null;
  const crtdlg = flgCrtDlg ? (
    <CreateGroupDialog dialog={actCrtDlg} exists={groupCombos?.map<number>((gc) => gc.index)} maxGroup={MaxGroup} />
  ) : null;
  // const [flgDlg, actDlg] = useModal<MessageDialogResponse>();
  // const [errmsg,setErrmsg] = useState<string>('');

  // const msgdlg = flgDlg?<MessageDialog dialog={actDlg} message={errmsg} />:null;

  console.log('-- RealtimeSetting --', cursorColor);

  const timePeriods: ComboBoxItemType[] = useMemo(() => {
    return [
      { index: 1, name: t('RealtimeSetting.1分', '1分') },
      { index: 10, name: t('RealtimeSetting.10分', '10分') },
      { index: 30, name: t('RealtimeSetting.30分', '30分') },
      { index: 60, name: t('RealtimeSetting.60分', '60分') },
    ];
  }, []);

  /**
   * 計測種別 言語切替
   */
  const changeLangMeasCombos = () => {
    //振動（速度）
    const idx1 = kindNoNameSets.findIndex((x) => x.NAME_NO == MeasureHighKind.VIBRATION_SPD);
    if (idx1 !== -1) {
      const name = GetVibrationSpecialString(MeasureHighKind.VIBRATION_SPD, t);
      kindNoNameSets[idx1].MES_NAME = name;
      measCombos[idx1].name = name;
    }
    //振動（変位）
    const idx2 = kindNoNameSets.findIndex((x) => x.NAME_NO == MeasureHighKind.VIBRATION_DSP);
    if (idx2 !== -1) {
      const name = GetVibrationSpecialString(MeasureHighKind.VIBRATION_DSP, t);
      kindNoNameSets[idx2].MES_NAME = name;
      measCombos[idx2].name = name;
    }
    //console.debug('changeLangMeasCombos', kindNoNameSets, measCombos, idx1, idx2);

    setKindNoNameSets(kindNoNameSets);
    setMeasCombos(measCombos);
  };

  /**
   * データ種別 言語切替
   */
  const changeLangDataCombos = (newDataCombos: ComboBoxItemType[]) => {
    const data = newDataCombos.find((x) => x.index == MeasureClcType.eChr);
    //console.debug('changeLangDataCombos', data, newDataCombos);
    if (data) {
      data.name = GetMeasureClcName(data.index, data.name, t);
      setDataCombos(
        newDataCombos.map<ComboBoxItemType>((ci) => {
          return { index: ci.index, name: ci.name, tag: ci.tag };
        })
      );
    }
  };

  // 言語切替
  useEffect(() => {
    //console.debug(['TrendSetting useEffect', i18n, measCombos, dataCombos]);
    changeLangMeasCombos();
    changeLangDataCombos(dataCombos);
  }, [i18n.language]);

  useEffect(() => {
    GetRealtimeGroupList().then((result: GroupListType) => {
      //console.debug(['result', result]);
      setEditList(result.RT_TRD_GROUP_SETs);

      //特殊項目追加
      CreateSpecialDatTrendSettingParameter(result.TrendSettings, t);

      const defkind: KIND_NO_NAME_SET = { SPEED: -1, NAME_NO: -1, MES_NAME: '' };
      setKindNoNameSets([defkind].concat(result.TrendSettings.KIND_NO_NAME_SETs));

      const defPara: ComboBoxItemType = { index: 0, name: '' };

      setMeasCombos(
        [defPara].concat(
          result.TrendSettings.MeasKinds.map<ComboBoxItemType>((ci) => {
            return { index: ci.Key, name: ci.Disp, tag: ci.Tag };
          })
        )
      );
      setDeviceCombos(
        [defPara].concat(
          result.TrendSettings.DeviceLists.map<ComboBoxItemType>((ci) => {
            return { index: ci.Key, name: ci.Disp };
          })
        )
      );
      setItemCombos(
        [defPara].concat(
          result.TrendSettings.ItemLists.map<ComboBoxItemType>((ci) => {
            return { index: ci.Key, name: ci.Disp };
          })
        )
      );
      //演算種別
      setMClcTypeCombos(
        [defPara].concat(
          result.TrendSettings.MClcTypes.map<ComboBoxItemType>((ci) => {
            return { index: ci.Key, name: ci.Disp, tag: ci.Tag };
          })
        )
      );
      //データ種別
      //console.debug('setDataCombos', result.TrendSettings.DataKinds);
      const newDataCombos = result.TrendSettings.DataKinds.map<ComboBoxItemType>((ci) => {
        return { index: ci.Key, name: ci.Disp, tag: ci.Tag };
      });
      changeLangDataCombos(newDataCombos);

      //異常種別 空文字除外
      setAlarmCombos(
        [defPara].concat(
          result.TrendSettings.AlarmKinds.map<ComboBoxItemType>((ci) => {
            return { index: ci.Key, name: ci.Disp, tag: ci.Tag };
          })
        )
      );
      setJudgeInfo(result.TrendSettings.AlarmLimits);
      setDeviceUnitInfo(result.TrendSettings.DeviceUnitInfos);
      setColSetInfo(result.TrendSettings.ColSetInfos);
      setJudgeSetSelect(result.TrendSettings.JudgeSetSelect);

      props.editData.SaveFunction = saveCurrentSetting;
      props.editData.IsUpdate = false;

      if (props.groupNo) {
        setGroupNo(props.groupNo);
      }
    });
  }, [props.editData.CancelCondition]);

  useEffect(() => {
    const groups = createComboList(editList);
    setGroupCombos(groups);

    if (!editList.find((el) => el.GROUP_NO == groupNo)) {
      if (editList.length > 0) {
        const grp = editList[0];
        setGroupNo(grp.GROUP_NO);
      }
    }
  }, [editList]);

  useEffect(() => {
    console.debug('-- groupChange --', groupNo);
    setSelectIdx(-1);
    const grp = editList.find((ed) => ed.GROUP_NO === groupNo);
    if (grp) {
      console.log('groupName', grp.GROUP_NAME);
      setGroupName(grp.GROUP_NAME ?? '');
      setCursorColor(grp.DSP_COLOR);
      setDispFlg(grp.DSP_FLG !== 0);
      setPeriod(grp.DSP_SPAN);
      setAutoUpdate(grp.AUT_UPDATE !== 0);
    } else {
      console.debug('not found group');
    }

    GetRealtimeSetting(groupNo).then((result: V_RT_TREND_SETTING_ITEM[]) => {
      var setItems: V_RT_TREND_SETTING_ITEM[] = [];
      //KINDを確認して、特殊な信号だった場合KIND_NOを入れ替える
      //MCLC_TYP_IDがNULLなら、デフォルトで０を設定
      result.forEach((r) => {
        //コナンエアの場合SET_NO＝KIND_NOとする
        if (IsConanAirPlc(String(r.PLC_NO))) {
          r.KIND_NO = r.SET_NO;
        }

        var spNo = GetVibrationSpecialNo(r.KIND);
        if (spNo !== '0') {
          r.KIND_NO = Number(spNo);
        }
        if (r.MCLC_TYP_ID === null) {
          r.MCLC_TYP_ID = 0;
        }
      });
      for (let step = 0; step < MaxSettingRow; step++) {
        let penNo = step + 1;
        let index = result.findIndex((r) => r.PEN_NO == penNo);
        if (index === -1) {
          let insRow = getInitialItem();
          insRow.PEN_NO = penNo;
          insRow.DSP_COLOR = GetDefaultPenColor(penNo);
          setItems.push(insRow);
        } else {
          setItems.push(result[index]);
        }
      }
      console.debug(['result,setItemList', result, setItems]);
      setItemList(setItems);
    });
  }, [groupNo]);

  const groupNameChange = (name: string) => {
    const grp = editList.find((ed) => ed.GROUP_NO === groupNo);
    if (grp) {
      setGroupName(name);
      grp.GROUP_NAME = name;

      props.editData.Target = { group: grp, list: itemList };
      props.editData.IsUpdate = true;
    }
  };
  const saveCurrentSetting = (param: object): Promise<string> => {
    console.debug('saveCurrentSetting', param);

    return new Promise((resolve, reject) => {
      const sp = param as SaveParameter;
      if (sp && sp.group && sp.list) {
        const errmsg = ValidateSetting(sp.group, sp.list, sp.colset);
        if (errmsg === '') {
          PutRealtimeGroupSetting(sp.group, sp.list)
            .then((count: number) => {
              console.log(count);

              resolve('done');
            })
            .catch((reason) => reject(reason));
        } else {
          setDlgmsg(errmsg);
          actMsgDlg.open().apply((_) => setDlgmsg(''));
        }
      } else {
        reject('data nothing');
      }
    });
  };
  const deleteCurrentSetting = (param: object): Promise<string> => {
    return new Promise((resolve, reject) => {
      const sp = param as SaveParameter;
      if (sp && sp.group && sp.list) {
        PutRealtimeGroupSetting(sp.group, sp.list)
          .then((count: number) => {
            console.log(count);

            resolve('done');
          })
          .catch((reason) => reject(reason));
      } else {
        reject('data nothing');
      }
    });
  };
  const itemUpdate = (item: V_RT_TREND_SETTING_ITEM) => {
    console.debug(['itemUpdate,itemList,targetItem', itemList, item]);
    const idx = itemList.findIndex((itm) => itm.PEN_NO === item.PEN_NO);
    if (idx >= 0) {
      const temp = itemList.concat(); // 画面更新のためArrayの再生成

      let findCol;
      if (item.SPEED === SpeedKind.SPEED_CONAN) {
        findCol = colSetInfo.find(
          (csi) => csi.DEV_INDEX === item.DEV_INDEX && csi.SPEED === item.SPEED && csi.ITM_NAME_NO === item.ITM_NAME_NO
        );

        if (findCol) {
          item.PLC_NO = findCol.PLC_NO;
          item.AI_CARD = findCol.AI_CARD;
          item.AI_CH = findCol.AI_CH;
          item.UNIT = findCol.UNIT;
        }
      } else {
        findCol = colSetInfo.find(
          (csi) =>
            csi.KIND_NO === item.KIND_NO && csi.DEV_INDEX === item.DEV_INDEX && csi.ITM_NAME_NO === item.ITM_NAME_NO
        );
        if (findCol) {
          item.PLC_NO = findCol.PLC_NO;
          item.AI_CARD = findCol.AI_CARD;
          item.AI_CH = findCol.AI_CH;
          item.SET_NO = findCol.SET_NO;
          item.UNIT = findCol.UNIT;
          item.KIND_NO = findCol.KIND_NO;
        }
      }

      temp[idx] = item;
      setItemList(temp);

      const grp = editList.find((ed) => ed.GROUP_NO === groupNo);
      props.editData.Target = { group: grp, list: temp, colset: colSetInfo };
      props.editData.IsUpdate = true;
    }
  };

  const updateCursorColor = (color: number) => {
    setCursorColor(color);

    const grp = editList.find((ed) => ed.GROUP_NO === groupNo);
    if (grp) {
      grp.DSP_COLOR = color;

      props.editData.Target = { group: grp, list: itemList, colset: colSetInfo };
      props.editData.IsUpdate = true;
    }
  };

  const getInitialItem = (): V_RT_TREND_SETTING_ITEM => {
    return {
      GROUP_NO: groupNo,
      PEN_NO: 0,
      DSP_FLG: 0,
      DSP_COLOR: 0,
      GRP_LOW: 0,
      GRP_HIGH: 0,
      SCALE_ON: 0,
      PLC_NO: 0,
      AI_CARD: 0,
      AI_CH: 0,
      TYP_NO: 0,
      MCLC_TYP_ID: 0,
      SET_NO: 0,
      DEV_INDEX: 0,
      DEV_NO: '',
      DEV_NAME: '',
      ITM_NAME_NO: 0,
      ITM_NAME: '',
      CLC: 0,
      RT_LMT_H: 0,
      RT_LMT_HH: 0,
      KIND_NO: 0,
      KIND: 0,
      UNIT: '',
      RH: 0,
      RL: 0,
      COL_RT_LMT_H: 0,
      COL_RT_LMT_HH: 0,
      MUL: 0,
      SPEED: 0,
      MES_NAME: '',
      LOG_INT: 0,
    };
  };

  //指定したアイテムが行データとして有効か確認
  const checkValidityItem = (item: V_RT_TREND_SETTING_ITEM): boolean => {
    if (item.SPEED !== 0 && item.KIND_NO !== 0) {
      return true;
    }
    if (item.DEV_INDEX !== 0) {
      return true;
    }
    if (item.ITM_NAME_NO !== 0) {
      return true;
    }
    return false;
  };
  const conditionRow = (source: V_RT_TREND_SETTING_ITEM[]): V_RT_TREND_SETTING_ITEM[] => {
    const temp = source.concat();
    if (temp.length < MaxSettingRow) {
      temp.push(getInitialItem());
    } else if (temp.length > MaxSettingRow) {
      temp.pop();
    }
    temp.forEach((item, idx) => (item.PEN_NO = idx + 1));
    return temp;
  };

  //行挿入
  const insertRow = () => {
    if (selectIdx == -1) {
      return;
    }
    const last = itemList.slice(-1)[0];
    if (checkValidityItem(last)) {
      //インサートできない
      return;
    }
    //指定した行へ空データインサート
    itemList.splice(selectIdx, 0, getInitialItem());
    //末尾を削除
    itemList.pop();
    //ペンNo振りなおし
    itemList.forEach((item, idx) => (item.PEN_NO = idx + 1));
    for (let i = 0; i < itemList.length; i++) {
      if (itemList[i].DEV_INDEX === 0) {
        itemList[i].DSP_COLOR = GetDefaultPenColor(i + 1);
      }
    }
    console.debug(['setItemList', itemList]);
    setItemList(itemList.concat());

    const grp = editList.find((ed) => ed.GROUP_NO === groupNo);
    if (grp) {
      props.editData.Target = { group: grp, list: itemList, colset: colSetInfo };
      props.editData.IsUpdate = true;
    }
  };

  //行削除
  const deleteRow = () => {
    if (selectIdx == -1) {
      return;
    }
    //指定行を削除
    itemList.splice(selectIdx, 1);
    //末尾に行追加
    itemList.push(getInitialItem());
    //ペンNo振りなおし
    itemList.forEach((item, idx) => (item.PEN_NO = idx + 1));
    for (let i = 0; i < itemList.length; i++) {
      if (itemList[i].DEV_INDEX === 0) {
        itemList[i].DSP_COLOR = GetDefaultPenColor(i + 1);
      }
    }

    setItemList(itemList.concat());

    const grp = editList.find((ed) => ed.GROUP_NO === groupNo);
    if (grp) {
      props.editData.Target = { group: grp, list: itemList, colset: colSetInfo };
      props.editData.IsUpdate = true;
    }
  };
  const upRow = () => {
    if (selectIdx == -1) {
      setSelectIdx(0);
      return;
    }
    if (selectIdx > 0) {
      const trg = itemList[selectIdx];
      itemList[selectIdx] = itemList[selectIdx - 1];
      itemList[selectIdx - 1] = trg;
      if (itemList[selectIdx].DEV_INDEX === 0) {
        itemList[selectIdx].DSP_COLOR = GetDefaultPenColor(selectIdx + 1);
      }
      setItemList(conditionRow(itemList));
      setSelectIdx(selectIdx - 1);

      const grp = editList.find((ed) => ed.GROUP_NO === groupNo);
      if (grp) {
        props.editData.Target = { group: grp, list: itemList, colset: colSetInfo };
        props.editData.IsUpdate = true;
      }
    }
  };
  const downRow = () => {
    if (selectIdx == -1) {
      setSelectIdx(0);
      return;
    }
    if (selectIdx < MaxSettingRow - 1) {
      const trg = itemList[selectIdx];
      itemList[selectIdx] = itemList[selectIdx + 1];
      itemList[selectIdx + 1] = trg;
      if (itemList[selectIdx].DEV_INDEX === 0) {
        itemList[selectIdx].DSP_COLOR = GetDefaultPenColor(selectIdx + 1);
      }
      setItemList(conditionRow(itemList));
      setSelectIdx(selectIdx + 1);

      const grp = editList.find((ed) => ed.GROUP_NO === groupNo);
      if (grp) {
        props.editData.Target = { group: grp, list: itemList, colset: colSetInfo };
        props.editData.IsUpdate = true;
      }
    }
  };
  const updateDisp = (disp: boolean) => {
    setDispFlg(disp);
    const grp = editList.find((ed) => ed.GROUP_NO === groupNo);
    if (grp) {
      grp.DSP_FLG = disp ? 1 : 0;

      props.editData.Target = { group: grp, list: itemList, colset: colSetInfo };
      props.editData.IsUpdate = true;
    }
  };
  const updatePeriod = (val: number) => {
    setPeriod(val);
    const grp = editList.find((ed) => ed.GROUP_NO === groupNo);
    if (grp) {
      grp.DSP_SPAN = val;

      props.editData.Target = { group: grp, list: itemList, colset: colSetInfo };
      props.editData.IsUpdate = true;
    }
  };
  const updateAutoUpdate = (flag: boolean) => {
    setAutoUpdate(flag);
    const grp = editList.find((ed) => ed.GROUP_NO === groupNo);
    if (grp) {
      grp.AUT_UPDATE = flag ? 1 : 0;

      props.editData.Target = { group: grp, list: itemList, colset: colSetInfo };
      props.editData.IsUpdate = true;
    }
  };

  const allDisp = () => {
    itemList.forEach((itm) => {
      itm.DSP_FLG = 1;
    });
    const temp = itemList.concat(); // 画面更新のためArrayの再生成
    setItemList(temp);

    const grp = editList.find((ed) => ed.GROUP_NO === groupNo);
    props.editData.Target = { group: grp, list: temp, colset: colSetInfo };
    props.editData.IsUpdate = true;
  };

  const ValidateSetting = (
    group: RT_TRD_GROUP_SET,
    items: V_RT_TREND_SETTING_ITEM[],
    colsets: ColSetInfo[]
  ): string => {
    if (group.GROUP_NAME == '') {
      return t('RealtimeSetting.グループ名必須', 'グループ名は必須です');
    }
    /* 全行の空チェック */
    if (items.filter((r) => r.DEV_INDEX !== 0).length === 0) {
      return t('TrendSetting.リストが空のためグループが削除されます', 'リストが空のためグループが削除されます');
    }

    for (var idx = 0; idx < items.length; idx++) {
      const item = items[idx];
      const itemNoInfo: string = 'no:' + String(idx + 1) + ' ';
      //console.debug(['checkValidityItem() res:', checkValidityItem(item), item]);
      if (checkValidityItem(item)) {
        let trg;
        if (item.SPEED === SpeedKind.SPEED_CONAN) {
          //コナンエアの場合
          trg = colsets.find((colset) => {
            return (
              colset.DEV_INDEX === item.DEV_INDEX &&
              colset.SPEED === item.SPEED &&
              colset.ITM_NAME_NO === item.ITM_NAME_NO
            );
          });
        } else {
          trg = colsets.find((colset) => {
            return (
              colset.KIND_NO === item.KIND_NO &&
              colset.DEV_INDEX === item.DEV_INDEX &&
              colset.ITM_NAME_NO === item.ITM_NAME_NO &&
              colset.SPEED === item.SPEED
            );
          });
        }

        // console.debug(['colsets', colsets]);
        // var dbg = colsets.filter((r) => r.KIND_NO == 3 && r.DEV_INDEX === 125);
        // console.debug(['dbg', dbg]);
        if (trg) {
          if (item.KIND_NO !== 0 && item.DEV_INDEX !== 0 && item.ITM_NAME_NO !== 0) {
            if (item.CLC === 0) {
              return (
                itemNoInfo +
                t('RealtimeSetting.登録データが不正です。(データ種別)', '登録データが不正です。(データ種別)')
              );
            }
            if (item.MCLC_TYP_ID === 0) {
              return (
                itemNoInfo + t('RealtimeSetting.登録データが不正です。(演算種別)', '登録データが不正です。(演算種別)')
              );
            }
            if (item.TYP_NO === 0) {
              return (
                itemNoInfo + t('RealtimeSetting.登録データが不正です。(異常内容)', '登録データが不正です。(異常内容)')
              );
            }

            if (item.SPEED != 1) {
              if (item.RT_LMT_H === 0 && item.RT_LMT_HH === 0) {
                return (
                  itemNoInfo +
                  t(
                    'RealtimeSetting.登録データが不正です。警報閾値(軽故障、重故障 両値0)',
                    '登録データが不正です。警報閾値(軽故障、重故障 両値0)'
                  )
                );
              } else if (item.RT_LMT_H > item.RT_LMT_HH) {
                return (
                  itemNoInfo +
                  t(
                    'RealtimeSetting.登録データが不正です。警報閾値(軽故障>重故障)',
                    '登録データが不正です。警報閾値(軽故障>重故障)'
                  )
                );
              }
            } else {
              if (item.COL_RT_LMT_H === 0 && item.COL_RT_LMT_HH === 0) {
                return (
                  itemNoInfo +
                  t(
                    'RealtimeSetting.登録データが不正です。警報閾値(軽故障、重故障 両値0)',
                    '登録データが不正です。警報閾値(軽故障、重故障 両値0)'
                  )
                );
              } else if (item.COL_RT_LMT_H > item.COL_RT_LMT_HH) {
                return (
                  itemNoInfo +
                  t(
                    'RealtimeSetting.登録データが不正です。警報閾値(軽故障>重故障)',
                    '登録データが不正です。警報閾値(軽故障>重故障)'
                  )
                );
              }
            }

            // if (item.GRP_LOW >= item.GRP_HIGH) {
            //   return (
            //     itemNoInfo +
            //     t(
            //       'RealtimeSetting.登録データが不正です。(グラフ最小値>=グラフ最大値)',
            //       '登録データが不正です。(グラフ最小値>=グラフ最大値)'
            //     )
            //   );
            // }
          }
        } else {
          console.debug(['colsets,item, index', colsets, item, idx]);
          return (
            itemNoInfo +
            t(
              'RealtimeSetting.指定された項目が見つかりません。(機器番号・項目名称からPLCNo.、AIカードNo.、CHNo.を検索)',
              '指定された項目が見つかりません。(機器番号・項目名称からPLCNo.、AIカードNo.、CHNo.を検索)'
            )
          );
        }
      }
    }
    return '';
  };

  return (
    <div>
      <TableContainer>
        <div className={pageStyle.itemRow}>
          <div className={pageStyle.itemSelLabel}>{t('RealtimeSetting.グループNo', 'グループNo')}</div>
          <div className={pageStyle.itemSelData}>
            <ItemComboBox
              itemList={groupCombos}
              label=""
              value={groupNo}
              onChangeEvent={(e) => {
                if (typeof e.target.value === 'number') {
                  setGroupNo(e.target.value);
                } else if (typeof e.target.value === 'string') {
                  setGroupNo(parseInt(e.target.value));
                }
              }}
            />
          </div>
          <div className={pageStyle.itemSelLabel}>{t('RealtimeSetting.グループ名称', 'グループ名称')}</div>
          <div className={pageStyle.itemSelData}>
            <TextField
              value={groupName}
              inputProps={{ maxLength: 32 }}
              onChange={(e) => {
                groupNameChange(e.target.value);
              }}
            />
          </div>
        </div>
        <div className={pageStyle.itemRow}>
          {/* <div className={pageStyle.itemSelLabel}>{t('RealtimeSetting.表示', '表示')}</div>
          <div className={pageStyle.itemSelData}>
            <Checkbox
              checked={dispFlg}
              onChange={(e) => {
                updateDisp(e.target.checked);
              }}
            />
          </div> */}
          <div className={pageStyle.itemSelData}>
            <ItemComboBox
              labelStyle={pageStyle.comboLabel}
              itemList={timePeriods}
              label={t('RealtimeSetting.表示周期', '表示周期')}
              value={period}
              onChangeEvent={(e) => {
                if (typeof e.target.value === 'string') {
                  updatePeriod(parseInt(e.target.value));
                }
              }}
            />
          </div>
          {/* <div className={pageStyle.itemSelLabel}>{t('RealtimeSetting.カーソル', 'カーソル')}</div>
          <div className={pageStyle.itemSelData}>
            <ColorPicker color={cursorColor} setColor={updateCursorColor} />
          </div>
          <div className={pageStyle.itemSelLabel}>{t('RealtimeSetting.自動更新', '自動更新')}</div>
          <div className={pageStyle.itemSelData}>
            <Checkbox
              checked={autoUpdate}
              onChange={(e) => {
                updateAutoUpdate(e.target.checked);
              }}
            />
          </div> */}
        </div>

        <div className={pageStyle.settingContainer}>
          <Table className={pageStyle.gridStyle} size="small">
            <TableHead>
              <TableRow>
                <TableCell className={tableStyle.headerCell} colSpan={2}>
                  {t('RealtimeSetting.表示', '表示')}
                </TableCell>
                <TableCell className={tableStyle.headerCell} rowSpan={2}>
                  {t('RealtimeSetting.計測種別', '計測種別')}
                </TableCell>
                <TableCell className={tableStyle.headerCell} rowSpan={2}>
                  {t('RealtimeSetting.機器番号_機器名称', '機器番号・機器名称')}
                </TableCell>
                <TableCell className={tableStyle.headerCell} rowSpan={2}>
                  {t('RealtimeSetting.項目名称', '項目名称')}
                </TableCell>
                <TableCell className={tableStyle.headerCell} rowSpan={2}>
                  {t('RealtimeSetting.データ種別', 'データ種別')}
                </TableCell>
                <TableCell className={tableStyle.headerCell} rowSpan={2}>
                  {t('RealtimeSetting.演算種別', '演算種別')}
                </TableCell>
                <TableCell className={tableStyle.headerCell} rowSpan={2}>
                  {t('RealtimeSetting.異常種別', '異常種別')}
                </TableCell>
                <TableCell className={tableStyle.headerCell} colSpan={2}>
                  {t('RealtimeSetting.警報閾値', '警報閾値')}
                </TableCell>
                {/* <TableCell className={tableStyle.headerCell} rowSpan={2}>
                  {t('RealtimeSetting.グラフ最小値', 'グラフ最小値')}
                </TableCell>
                <TableCell className={tableStyle.headerCell} rowSpan={2}>
                  {t('RealtimeSetting.グラフ最大値', 'グラフ最大値')}
                </TableCell> */}
                <TableCell className={tableStyle.headerCell} rowSpan={2}>
                  {t('RealtimeSetting.単位', '単位')}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={tableStyle.headerCell_s}>{t('RealtimeSetting.有', '有')}</TableCell>
                <TableCell className={tableStyle.headerCell_s}>{t('RealtimeSetting.線', '線')}</TableCell>
                <TableCell className={tableStyle.headerCell}>{t('RealtimeSetting.軽故障', '軽故障')}</TableCell>
                <TableCell className={tableStyle.headerCell}>{t('RealtimeSetting.重故障', '重故障')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {itemList.map((item, idx) => {
                return (
                  <RealtimeSettingItem
                    rowno={idx}
                    selectIdx={selectIdx}
                    setSelectIdx={setSelectIdx}
                    item={item}
                    updateItem={itemUpdate}
                    measKinds={measCombos}
                    deviceLists={deviceCombos}
                    itemLists={itemCombos}
                    dataKinds={dataCombos}
                    alarmKinds={alarmCombos}
                    alarmLimits={judgeInfo}
                    colSetInfos={colSetInfo}
                    kindNoNameSets={kindNoNameSets}
                    mClcTypes={mClcTypeCombos}
                    judgeSetSelect={judgeSetSelect}
                  />
                );
              })}
            </TableBody>
          </Table>
          <ListControl
            insertAction={() => insertRow()}
            deleteAction={() => deleteRow()}
            upAction={() => upRow()}
            downAction={() => downRow()}
          />
        </div>
        <div className={pageStyle.container}>
          <Button
            className={pageStyle.button}
            variant="contained"
            color="primary"
            onClick={(e) => {
              allDisp();
            }}
          >
            {t('RealtimeSetting.すべて表示', 'すべて表示')}
          </Button>

          <SaveCancel
            saveAction={() => {
              setDlgmsg(t('RealtimeSetting.保存しますか?', '保存しますか?'));
              actCfmDlg
                .open()
                .apply((_) => {
                  const grp = editList.find((ed) => ed.GROUP_NO === groupNo);
                  if (grp) {
                    saveCurrentSetting({ group: grp, list: itemList, colset: colSetInfo }).then((_) => {
                      props.editData.IsSaveClose = true;
                      props.editData.IsUpdate = false;
                      if (props.isDialog) {
                        props.editData.CloseSetting();
                      }
                    });
                  }
                })
                .cancel(() => { });
            }}
            cancelAction={() => {
              if (props.editData.IsUpdate) {
                setDlgmsg(
                  t(
                    'RealtimeSetting.保存していないデータを破棄します。\nよろしいですか?',
                    '保存していないデータを破棄します。\nよろしいですか?'
                  )
                );
                actCfmDlg
                  .open()
                  .apply((_) => {
                    if (props.isDialog) {
                      props.editData.IsUpdate = false;
                      props.editData.CloseSetting();
                    } else {
                      setEditList([]);
                      setGroupNo(0);
                      props.editData.UpdateCancel();
                    }
                  })
                  .cancel(() => { });
              } else {
                if (props.isDialog) {
                  props.editData.CloseSetting();
                }
              }
            }}
            createAction={() => {
              actCrtDlg.open().apply((info) => {
                const grp = editList.find((ed) => ed.GROUP_NO == info.no);
                if (!grp) {
                  const newGrp: RT_TRD_GROUP_SET = {
                    GROUP_NO: info.no,
                    GROUP_NAME: '',
                    DSP_FLG: 1,
                    DSP_COLOR: cursorColor,
                    AUT_UPDATE: 0,
                    DSP_SPAN: 1,
                  };
                  const newList = editList.concat(newGrp).sort((g1, g2) => g1.GROUP_NO - g2.GROUP_NO);
                  setEditList(newList);
                }
                setGroupNo(info.no);
              });
            }}
            deleteAction={() => {
              setDlgmsg(t('RealtimeSetting.削除しますか?', '削除しますか?'));
              actCfmDlg.open().apply((_) => {
                const grp = editList.find((ed) => ed.GROUP_NO == groupNo);
                if (grp) {
                  grp.GROUP_NAME = '';
                  deleteCurrentSetting({ group: grp, list: [], colset: colSetInfo }).then((_) => {
                    props.editData.IsSaveClose = true;
                    props.editData.IsUpdate = false;
                    const newEditList = editList.filter((ed) => ed.GROUP_NO != groupNo);
                    setEditList(newEditList);
                  });
                }
              });
            }}
          />
        </div>
      </TableContainer>
      {cfmdlg}
      {msgdlg}
      {crtdlg}
    </div>
  );
};

RealtimeSettingPage.defaultProps = { isDialog: false };

export default RealtimeSettingPage;
